module.exports = __webpack_public_path__ + "img/function_02.aa3833a6.png";